import { login, getInfo, logout } from '@/api/login'
// import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: '',
    username: '',
    name: '',
    email: '',
    avatar: '',
    role: ''
  },
  getters: {
    token: state => state.token,
    avatar: state => state.avatar,
    username: state => state.username,
    name: state => state.name,
    email: state => state.email,
    role: state => state.role
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_EMAIL: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLE: (state, role) => {
      state.role = role
    }
  },

  actions: {
    Login({ dispatch, commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response
          // console.log('data: ' + data)
          // setToken(data.jwt)
          commit('SET_TOKEN', data.access_token)
          commit('SET_NAME', data.user.name)
          commit('SET_USERNAME', data.user.username)
          commit('SET_EMAIL', data.user.email)

          // dispatch('resetChain')
          // commit('SET_ROLE', data.user.role.type)
          // commit('SET_EMAIL', data.user.email)
          // commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.user.username}`)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response
          if (data.role) {
            commit('SET_ROLE', data.role)
          } else {
            reject('getInfo: role not found !')
          }
          commit('SET_NAME', data.user.name)
          commit('SET_USERNAME', data.user.username)
          commit('SET_EMAIL', data.user.email)
          commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.user.name}`)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        logout().then(response => {
          commit('SET_TOKEN', '')
          commit('SET_ROLE', '')
          commit('SET_NAME', '')
          commit('SET_EMAIL', '')
          commit('SET_AVATAR', '')

          resolve()
        }).catch(error => {
          reject(error)
        })
        /* logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })*/
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        // removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js